import React, { useState, useEffect } from "react";
import Flex from '@react-css/flex';
import Modal from 'react-modal';
import { StyledForm } from "../../styled-components/StyledForm.style";
import api from '../../services/api';
import Swal from "sweetalert2";
import Select from 'react-select';

export const ModalAprovacoesConcluir = ({
    loadTable,
    isOpen,
    setIsOpen,
    pendenciaDeAprovacao
}) => {
    var [descricao, setDescricao] = useState(null);
    var [condicional, setCondicional] = useState(null);

    const style = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            borderRadius: "0px",
            minWidth: '35%',
            overflowY: 'auto',
            minHeight: '45%',
            maxHeight: '90%'
        },
        overlay: {
            zIndex: 9999
        }
    };

    const getCondicional = (condicional, condicionalResposta) => {
        if (!condicional) return

        setCondicional({
            idEtapaAprovacao: condicional.idEtapaAprovacao,
            IdEtapaCondicionalOpcao: condicionalResposta.value
        })
    };

    const onAfterOpen = () => { };

    const closeModal = () => {
        setIsOpen(false);
    }

    const handleDescricao = (descricao) => {
        setDescricao(descricao.target.value);
    }

    const formActivities = async () => {
        if (pendenciaDeAprovacao.condicional && condicional == null) {
            registrationInformation()
        }
        else {

            let payload = {
                idPendenciaAprovacao: pendenciaDeAprovacao.idPendenciaAprovacao,
                descricao: descricao,
                // Aprovado
                status: 2,
                // Concluir
                IdTipoAcao: 3,
                IdEtapaCondicionalOpcao: condicional?.IdEtapaCondicionalOpcao
            }

            Swal.fire({
                title: 'Aguarde...',
                html: 'Concluindo...',
                allowEscapeKey: false,
                allowOutsideClick: false,
                showConfirmButton: false,
                willOpen: () => {
                    Swal.showLoading()
                },
            });


            if(pendenciaDeAprovacao?.atividadesProbono > 0) {
                Swal.fire({
                    text: `Este TS possui ${pendenciaDeAprovacao?.totalHorasProBono} horas Pro bono, seguir com a aprovação?`,
                    showCancelButton: true,
                    showConfirmButton: true,
                    confirmButtonText: "Sim",
                    cancelButtonText: "Não",
                }).then(async (result) => {
                await api.put(`Aprovacoes/status`, payload)
                    .then(async (response) => {
                        await loadTable()
                        setIsOpen(false);
                        registrationSuccess();
                    })
                    .catch((error) => {
                        registrationFailure(error?.response?.data?.notification?.messageReturn)
                    });
                });
            }
            else {
            await api.put(`Aprovacoes/status`, payload)
                .then(async (response) => {
                    await loadTable()
                    setIsOpen(false);
                    registrationSuccess();
                })
                .catch((error) => {
                    registrationFailure(error?.response?.data?.notification?.messageReturn)
                });
            }
        }
    };

    const registrationSuccess = () => {
        Swal.fire({
            title: "Sucesso",
            text: "Aprovado com sucesso",
            icon: "success",
            showConfirmButton: false,
            timer: 2500,
        });
    }

    const registrationFailure = (text = "Ops, ocorreu um erro!. Tente novamente em instantes.") => {
        Swal.fire({
            title: "Atenção",
            text: text,
            icon: "error",
            confirmButtonText: "OK",
        });
    }

    const registrationInformation = () => {
        Swal.fire({
            title: "Informação",
            text: "Preencha todos os campos necessários",
            icon: "info",
            confirmButtonText: "OK",
        });
    }

    useEffect(() => {
        setCondicional(null);
        setDescricao(null);
    }, [pendenciaDeAprovacao])

    return (
        <Modal
            isOpen={isOpen}
            onAfterOpen={onAfterOpen}
            onRequestClose={closeModal}
            contentLabel="Aprovações concluir"
            style={style}
            ariaHideApp={false}
            shouldCloseOnOverlayClick={false}
        >
            <StyledForm>
                <p className="modal-close" onClick={closeModal}>X</p>
            </StyledForm>
            <StyledForm>
                <Flex>
                    <Flex.Item className="modal-width">
                        <p className="modal-title">Concluir</p>
                    </Flex.Item>
                </Flex>
                <Flex>
                    <Flex.Item className="modal-width">
                        <div className="position-relative form-group">
                            <div>
                                <p className="modal-info">Sigla</p>
                                <p className="modal-info-data"> {pendenciaDeAprovacao?.sigla} </p>
                                <p className="modal-info">Segurado</p>
                                <p className="modal-info-data"> {pendenciaDeAprovacao?.segurado?.seguradoNome} </p>
                                <p className="modal-info">Aprovador/Reprovador</p>
                                <p className="modal-info-data"> {pendenciaDeAprovacao?.nomeAprovador} </p>
                                {
                                    pendenciaDeAprovacao?.totalHorasProBono != '0,00' && (
                                        <>
                                            <p className="modal-info">Horas Pro Bono</p>
                                            <p className="modal-info-data"> {pendenciaDeAprovacao?.totalHorasProBono} </p>
                                        </>
                                    )
                                }
                            </div>
                        </div>
                    </Flex.Item>
                    <Flex.Item className="modal-width">
                        <div className="position-relative form-group">
                            <div>
                                <p className="modal-info">Empresa </p>
                                <p className="modal-info-data">{pendenciaDeAprovacao?.nomeEmpresa} </p>
                                <p className="modal-info">Cliente</p>
                                <p className="modal-info-data"> {pendenciaDeAprovacao?.cliente?.clienteNome} </p>
                                <p className="modal-info">Disciplina</p>
                                <p className="modal-info-data"> {pendenciaDeAprovacao?.disciplina} </p>
                                {
                                    pendenciaDeAprovacao?.totalValorProBono != 'R$ 0,00' && (
                                        <>
                                            <p className="modal-info">Valor Pro Bono</p>
                                            <p className="modal-info-data"> {pendenciaDeAprovacao?.totalValorProBono} </p>
                                        </>
                                    )
                                }
                            </div>
                        </div>
                    </Flex.Item>
                </Flex>

                <Flex>
                    <div style={{ width: '100%' }} className="position-relative form-group">
                        <p className="modal-info">{pendenciaDeAprovacao.condicional && pendenciaDeAprovacao.condicional[0].perguntaCondicional} </p>
                        {
                            pendenciaDeAprovacao.condicional &&
                            (
                                pendenciaDeAprovacao.condicional.map((item, index) => {
                                    return (
                                        <Select
                                            className="basic-single"
                                            placeholder={'Selecione uma resposta'}
                                            key={item.idEtapaAprovacao}
                                            options={item.condicionalOpcao}
                                            onChange={(condicional) => getCondicional(item, condicional)}
                                        />
                                    )
                                })
                            )
                        }
                    </div>
                </Flex>

                <Flex>
                    <div style={{ width: '100%' }} className="position-relative form-group">
                        <textarea rows="3" className="input-form" placeholder='Descrição' name='descricao' onBlur={handleDescricao} />
                    </div>
                </Flex>

                <Flex>
                    <Flex.Item className="modal-width">
                        <div className="position-relative form-group modal-align-center">
                            <input className='default-button-red' value='Concluir' type="button" onClick={formActivities} />
                        </div>
                    </Flex.Item>
                </Flex>
            </StyledForm>
        </Modal>);
};
